const AUTH_TOKEN = "authToken"
const USER_INFO = "loginUserInfo"
const GRID_FILTER_DATA = "gridFilterData"
const GRID_PAGE_SIZE = "gridPageSize"
const PAGE_CONDITION_DATA = "pageConditionData"
const EIGYOBI = "営業日"
const YOKUEIGYOBI = "翌営業日"
const YOKUYOKUEIGYOBI = "翌々営業日"
const ZENGETU = "前月"
const PERMISSION_PAGES = "permissionPages"
const ZYOMUINKADOTYOSEI = "乗務員稼働調整"

export const LOCALSTORAGE_PROPERTIES = {
  USER_INFO,
  AUTH_TOKEN,
  GRID_FILTER_DATA,
  GRID_PAGE_SIZE,
  PAGE_CONDITION_DATA,
  EIGYOBI,
  YOKUEIGYOBI,
  YOKUYOKUEIGYOBI,
  ZENGETU,
  PERMISSION_PAGES,
  ZYOMUINKADOTYOSEI,
}
